import { GetPremiumCTA } from 'components/PremiumCTA/GetPremiumCTA';

import './ModuleLibrary.scss';
import { ModuleCard } from 'components/ModuleCard/ModuleCard';
import { useServices } from 'index';
import { useQuery } from '@tanstack/react-query';
import { ModuleOverview } from 'types/module';
import { ModuleLoaderCard } from 'components/ModuleCard/ModuleLoaderCard/ModuleLoaderCard';

export const ModuleLibrary = () => {
  const learningHubService = useServices().learningHubService;
  const courseEditorService = useServices().courseEditorService;
  const profileService = useServices().profileService;

  const moduleList = useQuery({ queryKey: ['learningHubModuleList'], queryFn: learningHubService.getModules, refetchOnWindowFocus: false });
  const courses = useQuery({
    queryKey: ['adminCoursesList'],
    queryFn: courseEditorService.getCourses,
    staleTime: Infinity,
  });
  const isUserMember = useQuery({
    queryKey: ['isUserMember'],
    queryFn: profileService.checkIfUserIsMember,
    refetchOnWindowFocus: false,
  });

  return (
    <div className='modules-tab'>
      {!isUserMember.data && <GetPremiumCTA />}
      <ModulesGrid
        modules={moduleList.data}
        isPending={moduleList.isPending}
        isAdmin={Array.isArray(courses.data) && courses.data.length > 0}
      />
    </div>
  );
};

type ModulesGridProps = {
  modules: ModuleOverview[] | undefined;
  isPending: boolean;
  isAdmin: boolean;
};
const ModulesGrid = ({ modules, isPending, isAdmin }: ModulesGridProps) => {
  return (
    <div className='modules-grid'>
      {!isPending
        ? modules?.map((module) => <ModuleCard key={module.id} module={module} isAdmin={isAdmin} />)
        : Array.from(Array(10)).map((el, index) => <ModuleLoaderCard key={index} />)}
    </div>
  );
};
